// extracted by mini-css-extract-plugin
export default {"rating":"rating_rating__8l2CP"};